import React, { useEffect } from 'react'

import { SegmentAction, segmentTracking } from 'src/helpers/segment'

import './ProposalLoadingInterstitial.scss'
import {
  ProposalLoadingStage,
  getProposalLoadingStageConfig,
  useTimedProposalLoadingStage,
} from './proposalLoadingStages'

interface ProposalLoadingInterstitialProps {
  stage?: ProposalLoadingStage
}

export const ProposalLoadingInterstitial = ({ stage }: ProposalLoadingInterstitialProps) => {
  const timedStage = useTimedProposalLoadingStage()

  useEffect(() => {
    const shownAt = Date.now()
    segmentTracking(SegmentAction.SQ_PROPOSAL_LOADING_SHOWN)

    return () => {
      // Unmount runs on the navigation to results, so a throwing analytics client must not reach React.
      try {
        segmentTracking(SegmentAction.SQ_PROPOSAL_LOADING_DISMISSED, { elapsedMs: Date.now() - shownAt })
      } catch {
        return
      }
    }
  }, [])

  const { headline, progressPercent, fillDurationMs } = getProposalLoadingStageConfig(stage || timedStage)

  return (
    <div className="loader_full_screen proposal-loading-interstitial">
      <div className="proposal-loading-inner">
        <h2 className="proposal-loading-headline">{headline}</h2>
        <div
          className="proposal-loading-progress"
          role="progressbar"
          aria-label="Building your proposal"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={progressPercent}
        >
          <div
            className="proposal-loading-progress-fill"
            data-testid="proposal-loading-progress-fill"
            style={
              {
                width: `${progressPercent}%`,
                '--proposal-loading-fill-duration': `${fillDurationMs}ms`,
              } as React.CSSProperties
            }
          />
        </div>
      </div>
    </div>
  )
}
